module.exports = __webpack_public_path__ + "img/theme1-gradient.d5946213.svg";